module.exports = __webpack_public_path__ + "img/playstore.d0b857b2.png";